const FEDERAL_BRACKETS = [
  [11925, 0.10], [48475, 0.12], [103350, 0.22],
  [197300, 0.24], [250525, 0.32], [626350, 0.35],
  [Infinity, 0.37]
];
const STANDARD_DEDUCTION = 15000;

export const SALARY_LEVELS = [40000, 50000, 60000, 70000, 80000, 90000, 100000, 120000, 150000, 200000];

export function calcFederalTax(gross) {
  let taxable = Math.max(0, gross - STANDARD_DEDUCTION);
  let tax = 0, prev = 0;
  for (const [bracket, rate] of FEDERAL_BRACKETS) {
    if (taxable <= 0) break;
    const amount = Math.min(taxable, bracket - prev);
    tax += amount * rate;
    taxable -= amount;
    prev = bracket;
  }
  return Math.round(tax * 100) / 100;
}

export function calcFica(gross) {
  const ss = Math.min(gross, 176100) * 0.062;
  let medicare = gross * 0.0145;
  if (gross > 200000) medicare += (gross - 200000) * 0.009;
  return Math.round((ss + medicare) * 100) / 100;
}

export function calcStateTax(gross, stateRate = 0, cityRate = 0) {
  return Math.round(gross * (stateRate + cityRate) * 100) / 100;
}

export function calculateBreakdown(salary, city) {
  const federal = calcFederalTax(salary);
  const fica = calcFica(salary);
  const state = calcStateTax(salary, city.state_tax_rate || 0, city.city_tax_rate || 0);
  const totalTax = federal + fica + state;
  const netAnnual = Math.round((salary - totalTax) * 100) / 100;
  const netMonthly = Math.round(netAnnual / 12 * 100) / 100;
  const rent = city.rent_1br || 0;
  const groceries = city.groceries || 0;
  const transport = city.transportation || 0;
  const utilities = city.utilities || 0;
  const healthcare = city.healthcare || 0;
  const totalExpenses = rent + groceries + transport + utilities + healthcare;
  const remaining = Math.round((netMonthly - totalExpenses) * 100) / 100;
  const rentRatio = netMonthly > 0 ? Math.round((rent / netMonthly * 100) * 10) / 10 : 999;

  let verdict;
  if (remaining > netMonthly * 0.2) verdict = "Comfortable";
  else if (remaining > 0) verdict = "Tight";
  else verdict = "Not Affordable";

  return {
    gross_salary: salary, federal_tax: federal, state_tax: state,
    fica_tax: fica, total_tax: totalTax, net_annual: netAnnual,
    net_monthly: netMonthly, rent_1br: rent, rent_2br: city.rent_2br || 0,
    groceries, transportation: transport, utilities, healthcare,
    total_monthly_expenses: totalExpenses, remaining_monthly: remaining,
    rent_to_income_ratio: rentRatio, verdict,
    city_name: city.name || '', state: city.state || '',
    state_code: city.state_code || '', col_index: city.col_index || 100
  };
}

export function formatMoney(num) {
  if (num === undefined || num === null) return '$0';
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(num);
}

export function formatPercent(num) {
  return `${num}%`;
}
